import { GridSortModel } from '@mui/x-data-grid-pro';

import { useLocalStorage } from '@/hooks/useLocalStorage';

/**
 * Generic hook for managing DataGrid sort state with localStorage persistence
 *
 * @param storageKey - Unique key for localStorage (e.g., 'employees-sort')
 * @param defaultSort - Optional default sort configuration
 * @returns Sort model state and setter
 */
export const useSortModel = (
  storageKey: string | null | undefined,
  defaultSort: GridSortModel = [],
) => {
  const [sortModel, setSortModel] = useLocalStorage<GridSortModel>(
    storageKey,
    defaultSort,
  );

  return {
    sortModel,
    setSortModel,
  };
};
